import React, { useEffect, useState } from 'react'
import { bool, element, node, oneOfType, string } from 'prop-types'
import { Link } from '@reach/router'
import { URLS_APP } from '../../config'

const LinkHOC = ( { to='', children, isUrlAbsoluta, ...props } ) => {
  const [ path, setPath ] = useState( to )

  useEffect( () => {
    if ( !isUrlAbsoluta && to && URLS_APP.BASE_PATH ) {
      setPath( URLS_APP.BASE_PATH + to )
    }
  }, [ isUrlAbsoluta, to ] )

  if ( !path ) {
    return null
  }

  return (
    <Link
      { ...props }
      to={ path }
    >
      { children }
    </Link>
  )
}

LinkHOC.defaultProps = {
  'children': null,
  'isUrlAbsoluta': false
}

LinkHOC.propTypes = {
  'children': oneOfType( [ element, node, string ] ),
  'isUrlAbsoluta': bool,
  'to': string.isRequired
}

export default LinkHOC
